import React from "react";
import { useTranslation } from "react-i18next";
import AuthPage from "./AuthPage.jsx";

export default function ResetPasswordForm({
  handleResetPassword,
  challengeResponse,
  setChallengeResponse,
  password,
  setPassword,
  error,
  onBack,
}) {
  const { t } = useTranslation();
  const inputClassName =
    "mt-1 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 shadow-sm outline-none transition focus:border-sky-600 focus:ring-2 focus:ring-sky-200";

  const handleSubmit = (event) => {
    event.preventDefault();
    handleResetPassword();
  };

  return (
    <AuthPage
      title={t("resetPasswordTitle")}
      subtitle={t("resetPasswordSubtitle")}
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label
            htmlFor="password-reset-code"
            className="text-sm font-medium text-slate-700"
          >
            {t("verificationCode")}
          </label>
          <input
            id="password-reset-code"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength="6"
            value={challengeResponse}
            onChange={(event) =>
              setChallengeResponse(event.target.value.replace(/\s/g, ""))
            }
            className={inputClassName}
            required
          />
        </div>
        <div>
          <label
            htmlFor="password-reset-new"
            className="text-sm font-medium text-slate-700"
          >
            {t("newPassword")}
          </label>
          <input
            id="password-reset-new"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className={inputClassName}
            required
          />
        </div>
        {error && (
          <p
            role="alert"
            className="rounded-lg bg-red-50 p-3 text-sm text-red-700"
          >
            {error}
          </p>
        )}
        <button
          type="submit"
          className="w-full rounded-lg bg-sky-600 px-4 py-3 font-semibold text-white transition hover:bg-sky-700"
        >
          {t("resetPassword")}
        </button>
        <button
          type="button"
          onClick={onBack}
          className="w-full text-sm font-medium text-sky-700 underline hover:text-sky-900"
        >
          {t("backToLogin")}
        </button>
      </form>
    </AuthPage>
  );
}
